import { render, staticRenderFns } from "./ChatSideBar.vue?vue&type=template&id=53136e5e&scoped=true"
import script from "./ChatSideBar.vue?vue&type=script&lang=js"
export * from "./ChatSideBar.vue?vue&type=script&lang=js"
import style0 from "./ChatSideBar.vue?vue&type=style&index=0&id=53136e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53136e5e",
  null
  
)

export default component.exports